import dayjs from 'dayjs';

/**
 * Converts a time in seconds to a human-readable format.
 * - If less than 60 seconds, returns "Xs".
 * - If between 60 seconds and 1 hour, returns "Xm Ys".
 * - If more than 1 hour, returns "Xh Ym Zs".
 */
export function getHumanReadableTime(seconds: number): string {
  if (seconds < 60) {
    return `${seconds}s`;
  } else if (seconds < 3600) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}m${remainingSeconds > 0 ? ` ${remainingSeconds}s` : ''}`;
  } else {
    const hours = Math.floor(seconds / 3600);
    const remainingMinutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    return `${hours}h${remainingMinutes > 0 ? ` ${remainingMinutes}m` : ''}${
      remainingSeconds > 0 ? ` ${remainingSeconds}s` : ''
    }`;
  }
}

/**
 * Calculates the time taken to complete a task given start and end times.
 * Returns a human-readable string representing the duration.
 */
export function getTimeTakenToComplete(startTime: string | number, endTime: string | number): string {
  const start = dayjs(startTime);
  const end = dayjs(endTime);
  const durationInSeconds = end.diff(start, 'second');
  return getHumanReadableTime(durationInSeconds);
}
